import HtmlRenderer from 'Utils/htmlRenederer.utils'
import styles from '../Prompt.module.less'

type PromptHTMLContentPropsType = {
    content: string
    id: string
}

export const PromptHTMLContent = (props: PromptHTMLContentPropsType) => {
    return (
        <div className={styles['html-content']} id={props.id} data-testid="html-content">
            <HtmlRenderer htmlContent={props.content} className={styles['html-renderer']} />
        </div>
    )
}
